import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

/**
 * Editorial hero for module landing pages (properties, wishes, ticketing).
 * Keep it off the home hub and provide all visible copy through i18n at the call site.
 */
export function EditorialHero({
  eyebrow,
  title,
  lede,
  actions,
  children,
  className,
}: {
  eyebrow?: ReactNode
  title: ReactNode
  lede?: ReactNode
  /** Call-to-action content is styled at the call site. */
  actions?: ReactNode
  children?: ReactNode
  className?: string
}) {
  return (
    <section
      className={cn(
        'relative isolate overflow-hidden rounded-xl px-6 py-10 text-white sm:px-10 sm:py-14',
        'bg-[linear-gradient(135deg,var(--hero-gradient-start)_0%,var(--hero-gradient-middle)_70%,var(--hero-gradient-end)_100%)]',
        className,
      )}
    >
      <div className="relative max-w-2xl">
        {eyebrow ? (
          <p className="mb-3 font-mono text-[12px] font-semibold uppercase tracking-[0.12em] text-white">
            {eyebrow}
          </p>
        ) : null}
        {/* The important modifier wins over the global unlayered heading color. */}
        <h1 className="font-display text-[clamp(2rem,5vw,3rem)] font-semibold leading-[1.08] tracking-[-0.02em] text-white!">
          {title}
        </h1>
        {lede ? <p className="mt-4 max-w-xl text-[17px] leading-relaxed text-white">{lede}</p> : null}
        {actions ? <div className="mt-6 flex flex-wrap gap-3">{actions}</div> : null}
        {children}
      </div>
    </section>
  )
}
